import { Auth0CallbackPath } from '../constants/auth0.constants';

export const accountRoutePaths = {
  Root: '/',
  Landing: '/landing',
  Login: '/login',
  Logout: '/logout',
  MyAccount: '/my-account',
  NoOrganisationAccess: '/no-organisation-access',
  Signup: '/signup',
  SignupFlow: '/signup/steps',
  SubscriptionsSelfServeMicroFrontend: '/self-serve',
  AcceptInvitation: '/accept_invitation',
  MobileGoogleBusinessOAuthBridge: '/mobile/oauth/google-business',
  MobileStripeConnectOAuthBridge: '/mobile/oauth/stripe-connect',
  Auth0Login: '/auth0login',
  Auth0LoginCallback: Auth0CallbackPath,
  UberEatsOAuthCallback: '/oauth/ubereats/callback',
};
